import React from "react";
import { withStyles, withTheme } from "@material-ui/core/styles";
import { Icon } from "@material-ui/core";
import classNames from "classnames";
import { navStyle } from "./nav_style";
import { NavContainer } from "./nav_container";
import PropTypes from "prop-types";

export const Nav = ({
    classes,
    items,
    bottomItems,
    selectItem,
    selected,
    rootStyle,
    type
}) => {
    const renderItems = (items, selected) => {
        return items.map(item => {
            return (
                <div
                    key={item.value}
                    className={classNames(classes.navItem, {
                        [classes.selected]: selected === item.value,
                        [classes[item.position]]: item.position
                    })}
                    onClick={() => selectItem(item.value)}
                >
                    {item.icon && <Icon>{item.icon}</Icon>}
                    <label>{item.label}</label>
                </div>
            );
        });
    };

    const renderBottom = buttomItems => {
        return bottomItems.map(item => {
            return (
                <div
                    key={item.value}
                    className={classNames(classes.navItem, {
                        [classes.selected]: selected === item.value,
                        [classes[item.position]]: item.position
                    })}
                    onClick={() => {
                        item.action
                            ? item.action(item.value)
                            : selectItem(item.value);
                    }}
                >
                    {item.icon && <Icon>{item.icon}</Icon>}
                    <label>{item.label}</label>
                </div>
            );
        });
    };

    return (
        <div
            className={classNames(classes.navBar, {
                [rootStyle]: rootStyle
            })}
        >
            <div className={classNames({ [classes[type]]: type })}>
                {renderItems(items, selected)}
                {bottomItems && (
                    <div className={classes.bottomNav}>
                        {renderBottom(bottomItems)}
                    </div>
                )}
            </div>
        </div>
    );
};

Nav.propTypes = {
    classes: PropTypes.object,
    rootStyle: PropTypes.string,
    selected: PropTypes.string,
    items: PropTypes.array.isRequired,
    bottomItems: PropTypes.array,
    selectItem: PropTypes.func.isRequired,
    type: PropTypes.oneOf([])
};

export default NavContainer(withTheme(withStyles(navStyle)(Nav)));
